import { useAuth } from "@/auth/AuthContext";
import { Center, Loader } from "@mantine/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function LogoutPage() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      await signOut();
      navigate("/");
    };

    handleLogout();
  }, [signOut, navigate]);

  // Display a loading indicator while logging out
  return (
    <Center style={{ height: "100vh" }}>
      <Loader />
    </Center>
  );
}
